export default "__VITE_ASSET__CYtQbaZT__"